module.exports = __webpack_public_path__ + "static/media/Add_Biller_Beneficiary.6333ae2f.svg";